/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StateResponseDto
 */
export interface StateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof StateResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StateResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StateResponseDto
     */
    iso: string;
}

/**
 * Check if a given object implements the StateResponseDto interface.
 */
export function instanceOfStateResponseDto(value: object): value is StateResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('iso' in value) || value['iso'] === undefined) return false;
    return true;
}

export function StateResponseDtoFromJSON(json: any): StateResponseDto {
    return StateResponseDtoFromJSONTyped(json, false);
}

export function StateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'iso': json['iso'],
    };
}

export function StateResponseDtoToJSON(json: any): StateResponseDto {
    return StateResponseDtoToJSONTyped(json, false);
}

export function StateResponseDtoToJSONTyped(value?: StateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'iso': value['iso'],
    };
}

